export default "__VITE_ASSET__lj6QnnSv__"